import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "@/lib/utils";

export function PasswordInput({ className, ...props }) {
  const [show, setShow] = useState(false);
  const tid = props["data-testid"];
  return (
    <div className="relative">
      <input {...props} type={show ? "text" : "password"} className={cn(className, "pr-10")} />
      <button type="button" onClick={() => setShow((s) => !s)} tabIndex={-1}
        aria-label={show ? "Hide password" : "Show password"} title={show ? "Hide password" : "Show password"}
        data-testid={tid ? `${tid}-toggle` : undefined}
        className="absolute right-2 top-1/2 -translate-y-1/2 rounded-md p-1 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600">
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}
